import type { Ref, ShallowRef } from "vue";
import type { FuseResult } from "fuse.js";
import { createContext } from "reka-ui";

export { default as CommandUsingFuse } from "./CommandUsingFuse.vue";
export { default as CommandSearchResultList } from "./CommandSearchResultList.vue";
export { default as CommandDialog } from "./CommandDialog.vue";
export { default as CommandEmpty } from "./CommandEmpty.vue";
export { default as CommandGroup } from "./CommandGroup.vue";
export { default as CommandInput } from "./CommandInput.vue";
export { default as CommandItem } from "./CommandItem.vue";
export { default as CommandList } from "./CommandList.vue";
export { default as CommandSeparator } from "./CommandSeparator.vue";
export { default as CommandShortcut } from "./CommandShortcut.vue";

export type SearchableItemID = string | Symbol | number;
export interface SearchableItem extends Record<string, unknown> {
  id: SearchableItemID;
  label: string;
}

export const [useCommand, provideCommandContext] = createContext<{
  /**
   * The text search input by the user.
   */
  search: Ref<string>;
  /**
   * Lookup table of search results by their item IDs.
   */
  searchResults: ShallowRef<FuseResult<SearchableItem>[]>;
  /**
   * Shallow reactive list of search results, sorted by the best match to the worst match.
   * Whether it includes all items depends on threshold settings in Fuse options.
   * Key is the {@link SearchableItem.id} ({@link SearchableItemID}), value is the corresponding
   * {@link FuseResult} that contains an `item` property with your {@link SearchableItem}.
   */
  searchResultsMap: ShallowRef<Map<SearchableItemID, FuseResult<SearchableItem>>>;
}>("CommandUsingFuse");
